import React from "react";
import { Paper, TextField, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { PrimaryButton, SecondaryButton } from "@prestosports/commons-ui";
import { DateUtils } from "@prestosports/prestostats-core/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import StreamStyles from "../styles/StreamStyles";
import DurationPicker from "./DurationPicker";
import StreamMarkerPlaySelector from "./StreamMarkerPlaySelector";

const StreamMarkerCreate = ({
	markers = [],
	marker = {},
	handleSave,
	handleCancel,
	snapshot,
	currentTime,
	footballPlays,
	gameConfig
}) => {
	const classes = StreamStyles();
	let restrictedTimes = markers.map(({ seconds }) => seconds);
	let restrictedPlayIds = markers
		.filter(({ playId }) => !!playId)
		.map(({ playId }) => playId);

	if (marker.id) {
		restrictedTimes = restrictedTimes.filter(
			(seconds) => seconds !== marker.seconds
		);
		restrictedPlayIds = restrictedPlayIds.filter(
			(playId) => playId !== marker.playId
		);
	}

	const formik = useFormik({
		enableReinitialize: false,
		validationSchema: Yup.object({
			description: Yup.string().required("Description is required"),
			seconds: Yup.number()
				.notOneOf(restrictedTimes, "Time is already in-use")
				.lessThan(snapshot.duration + 1, "Time is out of range"),
			playId: Yup.string()
				.nullable()
				.notOneOf(restrictedPlayIds, "Play is already in-use")
		}),
		initialValues: {
			id: null,
			description: "",
			seconds: currentTime,
			playId: null,
			...marker
		},
		onSubmit: (values) => {
			handleSave(values);
		}
	});

	const { handleSubmit, handleChange, setFieldValue, errors } = formik;

	const handleChangeTime = (duration = "00:00:00") => {
		setFieldValue("seconds", DateUtils.durationToSeconds(duration));
	};

	const handleChangePlay = (id) => {
		setFieldValue("playId", id);
	};

	return (
		<Box className={classes.streamMkrCreateContainer}>
			<form onSubmit={handleSubmit}>
				<Paper className={classes.streamMkrCreatePaper}>
					<Typography
						style={{ fontWeight: "bold" }}
						variant="caption"
						color="textPrimary"
					>
						{marker?.id ? "Update" : "Create"} Marker
					</Typography>
					<TextField
						helperText={errors.description}
						error={!!errors.description}
						size="small"
						id="description"
						name="description"
						label="Description"
						fullWidth
						value={formik.values.description}
						onChange={handleChange}
						InputLabelProps={{
							shrink: true
						}}
					/>
					<DurationPicker
						label="Time"
						handleDurationChange={handleChangeTime}
						value={DateUtils.formatMilliseconds(formik.values.seconds * 1000, [
							"hours",
							"minutes",
							"seconds"
						])}
						size="small"
						hideDialog
						helperText={errors.seconds}
						error={!!errors.seconds}
					/>

					<StreamMarkerPlaySelector
						footballPlays={footballPlays}
						gameConfig={gameConfig}
						value={formik.values.playId}
						error={!!errors.playId}
						errorMessage={errors.playId}
						handleChange={(_, value) => handleChangePlay(value)}
					/>

					<Box className={classes.streamMkrCreateBtnContainer}>
						<PrimaryButton
							disabled={Object.keys(errors).length}
							size="small"
							type="submit"
							color="primary"
							label="Save"
						/>
						<SecondaryButton
							onClick={handleCancel}
							size="small"
							color="secondary"
							label="Cancel"
						/>
					</Box>
				</Paper>
			</form>
		</Box>
	);
};

export default StreamMarkerCreate;
